import { gql } from '@apollo/client';

export const DeleteSmartImportMutationName = 'DeleteSmartImport';

export const DELETE_SMART_IMPORT_MUTATION = gql`
  mutation ${DeleteSmartImportMutationName}($id: ID!) {
    deleteSmartImport(id: $id) {
      id
      status
    }
  }
`;
